export const scale = 2
